import { Component } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { BaseQuantityselectionComponent } from './base-quantityselection.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-quantityselection',
    imports: [
    NgClass,
    NgTemplateOutlet,
    TranslatePipe
],
    templateUrl: './quantityselection.component.html',
    styleUrl: './quantityselection.component.scss'
})
export class QuantityselectionComponent extends BaseQuantityselectionComponent {

  constructor() {
    super()
  }

}
